// extracted by mini-css-extract-plugin
module.exports = {"container":"donut-chart_container__1OwkN","slice":"donut-chart_slice__3pgaP","hasHighlight":"donut-chart_hasHighlight__3cX65"};